<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">バンドルミックスマッチ検索</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="element-column">
          <div class="block-row">
            <div class="column-list">
              <label class="list-input-title">区分</label>
              <div class="list-input-content">
                <app-code-combo-box id="cmb_PromotionDiv" #cmb_PromotionDiv [forcedEnabledMode]="'true'"
                  [subid]="'cmb_PromotionDiv'" [(ngModel)]="kymw1309Model.promotionDiv" [codeDiv]="'ct350'" [tabindex]="0">
                </app-code-combo-box>
              </div>

              <label class="list-input-title">会員生協</label>
              <div class="list-input-content">
                <app-coop-code-combo-box id="cmb_Coop" [subid]="'cmb_Coop'" [forcedEnabledMode]="'true'"
                  [(ngModel)]="kymw1309Model.coop" [tabindex]="0"></app-coop-code-combo-box>
              </div>
            </div>

            <div class="column-list">
              <label class="list-input-title">部門コード</label>
              <div class="list-input-content">
                <app-class-code-combo-box id="cmb_ClassCode" [subid]="'cmb_ClassCode'" [forcedEnabledMode]="'true'"
                  [(ngModel)]="kymw1309Model.classCode" [tabindex]="0"></app-class-code-combo-box>
              </div>

              <label class="list-input-title">Ｐコード</label>
              <div class="list-input-content">
                <input type="text" id="txt_PCode" forcedEnabledMode="true" [(ngModel)]="kymw1309Model.pCode"
                  plessInputTextSub [restrict]="'[P0-9]'" [maxlength]="8" [tabindex]="0" class="pcode">
              </div>
            </div>

            <div class="column-list">
              <label class="list-input-title">名称</label>
              <div class="list-input-content">
                <app-text-input id="txt_PromotionName" [subid]="'txt_PromotionName'"
                  [(ngModel)]="kymw1309Model.promotionName" [restrict]="'[ -￮]'" [maxChars]="20"
                  [forcedEnabledMode]="'true'" [fullOnly]="true" [displayCountField]="false"
                  [tabindex]="0" style="width:21rem;"></app-text-input>
              </div>
            </div>
          </div>

          <button class="btn-secondary" id="btn_Search" #btn_Search forcedEnabledMode="true"
            (click)="eventSearch_CLICKHandler(null)" [tabindex]="0">検索
          </button>
        </div>

        <div>
          <!-- ヘッダーの高さはコンポーネントにて70pxと定義する（Wijmoの都合で仕方なく） -->
          <wj-flex-grid forcedEnabledMode="true" id="dtg_PromotionGoods" #dtg_PromotionGoods
            [itemsSource]="kymw1309Model.promotionInfo" [isReadOnly]="true" [headersVisibility]="'Column'"
            [allowDragging]="'None'" [tabindex]="-1">
            <wj-flex-grid-column [minWidth]="5" [header]="'プロモーションＮＯ'" [width]="134" [binding]="'promotionNo'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'プロモーション名称'" [width]="134" [binding]="'promotionName'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'区分'" [width]="100" [binding]="'promotionDivName'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'Ｐコード'" [width]="100"
              [binding]="'pCode'"></wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'商品名'" [width]="194" [binding]="'guideGoodsName'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'規格名'" [width]="136" [binding]="'guideStandardName'">
            </wj-flex-grid-column>

            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_SupplyPiceIB" [binding]="'thisTimeSupplyPriceIB'"
              [header]="'供給価格\n\nいばらき'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceIB">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_thisTimeCostPriceIB"
              [binding]="'thisTimeCostPriceIB'" [header]="'仕入価格\n\nいばらき'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceIB">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_ApprovedNumIB" [binding]="'approvedNumIB'"
              [header]="'成立数量\n\nいばらき'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedNumIB">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_ApprovedPriceIB" [binding]="'approvedPriceIB'"
              [header]="'成立価格\n\nいばらき'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedPriceIB">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_WakuwakuPointIB" [binding]="'wakuwakuPointIB'"
              [header]="'わくわく\nポイント\nいばらき'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.wakuwakuPointIB">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_thisTimeSupplyPriceTO"
              [binding]="'thisTimeSupplyPriceTO'" [header]="'供給価格\n\nとちぎ'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceTO">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_thisTimeCostPriceTO"
              [binding]="'thisTimeCostPriceTO'" [header]="'仕入価格\n\nとちぎ'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceTO">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_ApprovedNumTO" [binding]="'approvedNumTO'"
              [header]="'成立数量\n\nとちぎ'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedNumTO">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_ApprovedPriceTO" [binding]="'approvedPriceTO'"
              [header]="'成立価格\n\nとちぎ'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedPriceTO">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_WakuwakuPointTO" [binding]="'wakuwakuPointTO'"
              [header]="'わくわく\nポイント\nとちぎ'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.wakuwakuPointTO">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_thisTimeSupplyPriceGU"
              [binding]="'thisTimeSupplyPriceGU'" [header]="'供給価格\n\nぐんま'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceGU">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_thisTimeCostPriceGU"
              [binding]="'thisTimeCostPriceGU'" [header]="'仕入価格\n\nぐんま'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceGU">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_ApprovedNumGU" [binding]="'approvedNumGU'"
              [header]="'成立数量\n\nぐんま'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedNumGU">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_ApprovedPriceGU" [binding]="'approvedPriceGU'"
              [header]="'成立価格\n\nぐんま'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedPriceGU">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_WakuwakuPointGU" [binding]="'wakuwakuPointGU'"
              [header]="'わくわく\nポイント\nぐんま'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.wakuwakuPointGU">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_thisTimeSupplyPriceTI"
              [binding]="'thisTimeSupplyPriceTI'" [header]="'供給価格\n\nちば'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceTI">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_thisTimeCostPriceTI"
              [binding]="'thisTimeCostPriceTI'" [header]="'仕入価格\n\nちば'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceTI">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_ApprovedNumTI" [binding]="'approvedNumTI'"
              [header]="'成立数量\n\nちば'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedNumTI">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_ApprovedPriceTI" [binding]="'approvedPriceTI'"
              [header]="'成立価格\n\nちば'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedPriceTI">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_WakuwakuPointTI" [binding]="'wakuwakuPointTI'"
              [header]="'わくわく\nポイント\nちば'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.wakuwakuPointTI">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_thisTimeSupplyPriceSA"
              [binding]="'thisTimeSupplyPriceSA'" [header]="'供給価格\n\nさいたま'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceSA">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_thisTimeCostPriceSA"
              [binding]="'thisTimeCostPriceSA'" [header]="'仕入価格\n\nさいたま'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceSA">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_ApprovedNumSA" [binding]="'approvedNumSA'"
              [header]="'成立数量\n\nさいたま'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedNumSA">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_ApprovedPriceSA" [binding]="'approvedPriceSA'"
              [header]="'成立価格\n\nさいたま'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedPriceSA">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_WakuwakuPointSA" [binding]="'wakuwakuPointSA'"
              [header]="'わくわく\nポイント\nさいたま'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.wakuwakuPointSA">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_thisTimeSupplyPriceTK"
              [binding]="'thisTimeSupplyPriceTK'" [header]="'供給価格\n\nとうきょう'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceTK">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_thisTimeCostPriceTK"
              [binding]="'thisTimeCostPriceTK'" [header]="'仕入価格\n\nとうきょう'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceTK">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_ApprovedNumTK" [binding]="'approvedNumTK'"
              [header]="'成立数量\n\nとうきょう'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedNumTK">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_ApprovedPriceTK" [binding]="'approvedPriceTK'"
              [header]="'成立価格\n\nとうきょう'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedPriceTK">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_WakuwakuPointTK" [binding]="'wakuwakuPointTK'"
              [header]="'わくわく\nポイント\nとうきょう'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.wakuwakuPointTK">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_thisTimeSupplyPriceNA"
              [binding]="'thisTimeSupplyPriceNA'" [header]="'供給価格\n\nながの'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceNA">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_thisTimeCostPriceNA"
              [binding]="'thisTimeCostPriceNA'" [header]="'仕入価格\n\nながの'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceNA">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_ApprovedNumNA" [binding]="'approvedNumNA'"
              [header]="'成立数量\n\nながの'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedNumNA">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_ApprovedPriceNA" [binding]="'approvedPriceNA'"
              [header]="'成立価格\n\nながの'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedPriceNA">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_WakuwakuPointNA" [binding]="'wakuwakuPointNA'"
              [header]="'わくわく\nポイント\nながの'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.wakuwakuPointNA">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_thisTimeSupplyPriceNI"
              [binding]="'thisTimeSupplyPriceNI'" [header]="'供給価格\n\nにいがた'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceNI">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_thisTimeCostPriceNI"
              [binding]="'thisTimeCostPriceNI'" [header]="'仕入価格\n\nにいがた'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceNI">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_ApprovedNumNI" [binding]="'approvedNumNI'"
              [header]="'成立数量\n\nにいがた'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedNumNI">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_ApprovedPriceNI" [binding]="'approvedPriceNI'"
              [header]="'成立価格\n\nにいがた'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedPriceNI">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_WakuwakuPointNI" [binding]="'wakuwakuPointNI'"
              [header]="'わくわく\nポイント\nにいがた'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.wakuwakuPointNI">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_thisTimeSupplyPriceKU"
              [binding]="'thisTimeSupplyPriceKU'" [header]="'供給価格\n\nクルコ'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceKU">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_thisTimeCostPriceKU"
              [binding]="'thisTimeCostPriceKU'" [header]="'仕入価格\n\nクルコ'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceKU">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_ApprovedNumKU" [binding]="'approvedNumKU'"
              [header]="'成立数量\n\nクルコ'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedNumKU">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_ApprovedPriceKU" [binding]="'approvedPriceKU'"
              [header]="'成立価格\n\nクルコ'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.approvedPriceKU">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="95" id="col_WakuwakuPointKU" [binding]="'wakuwakuPointKU'"
              [header]="'わくわく\nポイント\nクルコ'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.wakuwakuPointKU">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
          </wj-flex-grid>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Select" class="btn-primary" forcedEnabledMode="true"
            (click)="eventSelect_CLICKHandler(null)" [tabindex]="0">選択</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>